import { render } from "./FullscreenViewer.vue?vue&type=template&id=5dd06131&scoped=true&ts=true"
import script from "./FullscreenViewer.vue?vue&type=script&lang=ts"
export * from "./FullscreenViewer.vue?vue&type=script&lang=ts"

import "./FullscreenViewer.vue?vue&type=style&index=0&id=5dd06131&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd06131"]])

export default __exports__